import api from './api';

/** Resensys hardware status / event-trigger APIs (proxied by Indus backend). */
const RESENSYS_HARDWARE_API_ENABLED = true;

const resensysService = {
  getHardwareStatus: (bridgeId, sensorId) => {
    if (!RESENSYS_HARDWARE_API_ENABLED) return Promise.resolve(null);
    return api.get(`/bridges/${bridgeId}/sensors/${sensorId}/resensys/status`);
  },

  getHardwareThresholds: (bridgeId, sensorId, axis) => {
    if (!RESENSYS_HARDWARE_API_ENABLED) return Promise.resolve(null);
    return api.get(`/bridges/${bridgeId}/sensors/${sensorId}/resensys/thresholds`, { axis });
  },

  /**
   * Save the single hardware event-trigger (mg).
   * DID = sensorSerialNo, SID = dataLoggerSerialNo (backend resolves; optional hints accepted).
   * pushToDevice: false = persist only; true = also POST change_event_trigger_threshold.
   */
  saveHardwareEventTrigger: (bridgeId, sensorId, data) => {
    if (!RESENSYS_HARDWARE_API_ENABLED) {
      return Promise.reject(new Error('Resensys hardware API is disabled.'));
    }
    return api.put(
      `/bridges/${bridgeId}/sensors/${sensorId}/hardware-event-trigger`,
      data
    );
  },

  /** Explicit push of one mg threshold to Resensys hardware. */
  pushHardwareThreshold: (bridgeId, sensorId, data = {}) => {
    if (!RESENSYS_HARDWARE_API_ENABLED) {
      return Promise.reject(new Error('Resensys hardware API is disabled.'));
    }
    return api.post(
      `/bridges/${bridgeId}/sensors/${sensorId}/resensys/push-threshold`,
      data
    );
  },

  /**
   * Live Resensys hardware event-trigger (mg).
   * GET /api/bridges/:bridgeId/sensors/:sensorId/resensys/event-trigger-threshold
   * Optional hints: did (data logger serial), sid (sensor serial).
   */
  getEventTriggerThreshold: (bridgeId, sensorId, params = {}) => {
    if (!RESENSYS_HARDWARE_API_ENABLED) return Promise.resolve(null);
    return api.get(
      `/bridges/${bridgeId}/sensors/${sensorId}/resensys/event-trigger-threshold`,
      params
    );
  },

  /**
   * Battery + charge status for one sensor.
   * GET /api/bridges/:bridgeId/sensors/:sensorId/resensys/battery
   * Optional hints: did (Resensys device id), sid (data logger serial — also used as did for SID).
   */
  getBattery: (bridgeId, sensorId, params = {}) =>
    api.get(`/bridges/${bridgeId}/sensors/${sensorId}/resensys/battery`, params),
};

export default resensysService;
